import dayjs from 'dayjs';
import { getLocal, updateLocal } from '@/utils/storage';
import { toast } from '@components/ui/toast/Toast';

export const sortObject = (obj) => {
  return Object.keys(obj).sort().reduce(function (result, key) {
    result[key] = obj[key];
    return result;
  }, {});
}

export const calculateValues = (lpa, ppa) => {
  const lp = parseFloat(lpa);
  const pp = parseFloat(ppa);
  let chg = 0;
  let pChg = 0;

  if (lp && pp) {
    chg = lp - pp;
    pChg = (chg / pp) * 100;
  }
  return {
    lp: lp.toFixed(2),
    chg: chg.toFixed(2),
    pChg: pChg.toFixed(2),
    prev: pp.toFixed(2),
  };
};

export const fmtINR = (val) => {

  if (!val) {
    return 0.00
  }
  return parseFloat(val).toLocaleString('en-IN', {
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'INR'
  });
};

export const isEmptyObject = (obj) => {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
};

export const tvATMSymbolMapping = {
  BANKEX: 'BSE INDEX BANKEX',
  BANKNIFTY: 'NIFTY BANK',
  CRUDEOIL: 'CRUDEOIL',
  FINNIFTY: 'NIFTY FIN SERVICE',
  HDFCBANK: 'HDFC BANK',
  INFY: 'INFOSYS',
  MIDCPNIFTY: 'NIFTY MIDCAP SELECT (MIDCPNIFTY)',
  NIFTY: 'NIFTY 50',
  RELIANCE: 'RELIANCE INDUSTRIES',
  SBIN: 'STATE BANK OF INDIA',
  TCS: 'TATA CONSULTANCY SERV LT',
};

export const getTvATMInstrumentName = (symbol) => {
  return tvATMSymbolMapping[symbol] || symbol;
};

export const formatAmount = (val) => {
  if (val === undefined || val === null || val === '-') return '-';
  return parseFloat(val).toLocaleString('en-IN', { maximumFractionDigits: 2 });
};

export const darkTheme = {
  layout: {
    background: { type: 'solid', color: '#0a0f1e' },
    textColor: '#D9D9D9',
  },
  timeScale: { borderColor: '#2d3748' },
  rightPriceScale: { borderColor: '#2d3748' },
  leftPriceScale: { borderColor: '#2d3748' },
};

export const lightTheme = {
  layout: {
    background: { type: 'solid', color: '#ffffff' },
    textColor: '#191919',
  },
  timeScale: {
    borderColor: '#cbd5e1',
  },
  rightPriceScale: {
    borderColor: '#cbd5e1',
  },
  leftPriceScale: {
    borderColor: '#cbd5e1',
  },
};

export const PERIOD_DAYS_MAP = {
  '1D': 1,
  '2D': 2,
  '5D': 5,
  '1M': 30,
};

export const RESOLUTIONS = ['1m', '3m', '5m', '15m', '30m', '1h'];
export const PERIODS = ['1D', '2D', '5D', '1M'];

export const toDateString = (unix) => {
  const d = new Date(unix * 1000);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const timeToLocal = (originalTime) => {
  const d = new Date(originalTime * 1000);
  return (
    Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      d.getHours(),
      d.getMinutes(),
      d.getSeconds(),
      d.getMilliseconds()
    ) / 1000
  );
};

export const encodeBase64 = (str) => {
  try {
    return btoa(str);
  } catch {
    return str;
  }
};

export const copyText = (text, label = 'Copied!') => {
  navigator.clipboard
    .writeText(text)
    .then(() => toast.success(label))
    .catch(() => toast.error('Unable to copy'));
};

export const timeToMinutes = (t) => {
  const [h, m] = t.split(':').map(Number);
  return h * 60 + m;
};

export const minutesToTime = (mins) => {
  const h = String(Math.floor(mins / 60)).padStart(2, '0');
  const m = String(mins % 60).padStart(2, '0');
  return `${h}:${m}`;
};

export const formatDisplayTime = (timeStr) => dayjs(`2000-01-01 ${timeStr}`).format('hh:mm A');

export const formatNumber = (val) => {
  if (val == null || isNaN(val)) return '-';
  return Number(val).toLocaleString('en-IN');
};

export const findATMStrike = (optionChain, spotPrice) => {
  let prevStrike = 0;
  for (let i = 0; i < optionChain.length; i++) {
    const strike = optionChain[i]?.strikePrice;
    if (!strike) continue;
    if (spotPrice < strike) {
      const midpoint = prevStrike + (strike - prevStrike) / 2;
      return midpoint > spotPrice
        ? { index: i - 1, atmStrike: prevStrike }
        : { index: i + 1, atmStrike: strike };
    }
    prevStrike = strike;
  }
  return { index: 0, atmStrike: prevStrike };
};

export const getHighsLowsSym = () => {
  return [
    { name: "All FNO Stocks", value: "all" },
    { name: "Nifty 50", value: "nifty" },
    { name: "BankNifty", value: "banknifty" },
    { name: "Nifty Next 50", value: "niftynxt50" },
    { name: "Sensex", value: "sensex" },
    { name: "MidcapNifty", value: "midcpnifty" }
  ];
};
